(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_subscription_qty"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const widgets = document.querySelectorAll("shrine-subscription-widget, .subscription-widget");
  if (!widgets.length) return;

  const clamp = (value, min = 1, max = 9999) => {
    if (typeof value === "string") value = parseInt(value, 10);
    if (Number.isNaN(value)) return min;
    if (value < min) return min;
    if (value > max) return max;
    return value;
  };

  widgets.forEach((widget) => {
    const oneTimeBox = widget.querySelector('[data-type="one_time"]');
    const subscriptionBox = widget.querySelector('[data-type="subscription"]');
    const oneTimeQtyWrapper = widget.querySelector(".subscription__quantity--one-time");

    // ===== 1) YOUR ORIGINAL HIDING LOGIC (unchanged) =====
    if (!oneTimeBox || !subscriptionBox || !oneTimeQtyWrapper) {
      return;
    }

    const updateVisibility = () => {
      const subscriptionSelected = subscriptionBox.classList.contains("subscription__box--selected");
      oneTimeQtyWrapper.style.display = subscriptionSelected ? "none" : "";
    };

    // Initial state (preselected option)
    updateVisibility();

    // Update when a box is clicked
    oneTimeBox.addEventListener("click", () => {
      requestAnimationFrame(updateVisibility);
    });
    subscriptionBox.addEventListener("click", () => {
      requestAnimationFrame(updateVisibility);
    });

    // ===== 2) QUANTITY SYNC (robust, interval-based) =====

    // We need the subscription quantity wrapper for syncing from both options
    const subscriptionQtyWrapper = widget.querySelector(".subscription__quantity--subscription");
    if (!subscriptionQtyWrapper) {
      // Hiding still works; syncing is skipped
      return;
    }

    // Find the product form and the real quantity input
    const productForm =
      widget.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!productForm) {
      return;
    }

    // This is the working block quantity: qty_input_name: 'quantity'
    const realQtyInput = productForm.querySelector('input[name="quantity"]');
    if (!realQtyInput) {
      return;
    }

    // Widget quantity inputs (you confirmed these names exist)
    const oneTimeQtyInput = widget.querySelector('input[name="one_time_quantity"]');
    const subscriptionQtyInput = widget.querySelector('input[name="subscription_quantity"]');
    if (!oneTimeQtyInput || !subscriptionQtyInput) {
      return;
    }

    const isSubscriptionSelected = () =>
      subscriptionBox.classList.contains("subscription__box--selected");

    const syncRealQuantityFromActive = () => {
      const subscriptionSelected = isSubscriptionSelected();
      const activeInput = subscriptionSelected ? subscriptionQtyInput : oneTimeQtyInput;

      if (!activeInput) return;

      const value = clamp(activeInput.value || "1");
      activeInput.value = String(value);
      realQtyInput.value = String(value);

      // If Shrine's JS listens to quantity, fire events
      ["input", "change"].forEach((type) => {
        const evt = new Event(type, {bubbles: true});
        realQtyInput.dispatchEvent(evt);
      });
    };

    // Initialize: copy from the currently active widget quantity into real
    syncRealQuantityFromActive();

    // Periodically re-sync in case Shrine Pro updates widget inputs
    // without triggering input/change events
    const intervalId = window.setInterval(syncRealQuantityFromActive, 200);

    // Optional clean-up if your theme ever removes/re-renders widgets dynamically
    document.addEventListener("pagehide", () => {
      window.clearInterval(intervalId);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
